export const makeStylesheetLink = (() => {
	let baseHref: null | string = null;
	return (path?: string): HTMLLinkElement => {
		if (baseHref == null) {
			const link: HTMLLinkElement | null = document.querySelector("head > link[data-gct-stylesheet]");
			baseHref = link?.href ?? "";
		}

		let href = baseHref;
		if (path !== undefined) {
			href = new URL(path, baseHref).toString();
		}

		return <link rel="stylesheet" href={href} /> as HTMLLinkElement;
	};
})();
